
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import TextField from '../../../../framework/fields/TextField.vue';
import DateField from '../../../../framework/fields/DateField.vue';
import NumberField from '../../../../framework/fields/NumberField.vue';
import SelectField from '../../../../framework/fields/SelectField.vue';
import { sharedState } from '../../../../framework/state';
import { getEnumerationOptions, getOptionLabel } from '../../../../framework/service/options';
import { dateToDbDateString } from '../../../../../common/framework/util/convert';

import { errorToast, successToast } from '../../../service/toast_service';
import { postVehicleUsage, getLatestVehicleUsage } from '../../../client/vehicle_usage_client';
import { NewVehicleUsage } from '../../../../../common/application/model/NewVehicleUsage';
import { VehicleUsageType } from '../../../../../common/application/model/enums/VehicleUsageType';
import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';

@Component({
    components: {
        TextField,
        ValidationObserver,
        NumberField,
        DateField,
        SelectField,
    },
})
export default class AddVehicleUsage extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.VEHICLE_USAGE;

    @Prop(String) readonly registrationNumber!: string;

    // State
    shared = sharedState;
    local = {
        vehicleUsageDate: new Date().toString(),
        row: {
            vehicleRegistrationNumber: '',
            vehicleUsageAmount: 0,
            vehicleUsageType: VehicleUsageType.UNSPECIFIED,
        } as NewVehicleUsage,
        previousVehicleUsages: [] as any[],
        vehicleUsageTypeOptions: [] as { id: string | undefined; label: string }[],
    };

    // Functions
    async mounted() {
        if (this.registrationNumber) {
            const latestUsage = await getLatestVehicleUsage(this.registrationNumber);

            this.local.row = {
                ...this.local.row,
                vehicleUsageAmount: latestUsage.vehicleUsageAmount,
                vehicleUsageType: latestUsage.vehicleUsageType,
                vehicleRegistrationNumber: this.registrationNumber.toUpperCase(),
            };

            this.local.previousVehicleUsages.push({
                vehicleUsageDate: new Date(),
                vehicleUsageAmount: latestUsage.vehicleUsageAmount,
                vehicleUsageType: latestUsage.vehicleUsageType,
            });
        }

        this.local.vehicleUsageTypeOptions = getEnumerationOptions(
            'VehicleUsageType',
            Object.keys(VehicleUsageType),
            this,
        );
    }

    add() {
        this.addResource(false);
    }

    addAndClose() {
        this.addResource(true);
    }

    async addResource(goBack: boolean) {
        try {
            const newVehicleUsage = await postVehicleUsage({
                ...this.local.row,
                vehicleUsageDate: new Date(this.local.vehicleUsageDate),
            });

            successToast(this, 'message.vehicleUsageSaved');

            if (goBack) {
                this.back();
            } else {
                this.$router.replace(`/${this.resourceType}/${newVehicleUsage.id}/edit`);
            }
        } catch (error) {
            errorToast(this);
        }
    }

    back() {
        this.$router.go(-1);
    }

    dateToString(date: Date): string {
        return dateToDbDateString(date);
    }

    getUsageTypeLabel(id: string): string {
        return getOptionLabel(id, this.local.vehicleUsageTypeOptions);
    }
}
